
import create from "zustand";

// por si no hay internet
var obj
if ( true ) {
    obj = {
        email: null,
        nombre: null,
        apellido: null,
        token: null,
        permitido: null,
        exp: null
    }
} else {
    obj = {
        email: 'jsalcido@utescuinapa.edu.mx',
        nombre: 'Jesús Manuel',
        apellido: 'Salcido Aguilar',
        token: null,
        permitido: true,
        exp: null
    }
}


obj = JSON.parse(localStorage.getItem('user_empleado')) || obj

export const useEmpleadoStore = create( set => ({
    correo: null,
    actualizar: correo => set( state => ({
        correo
    })),


    carpeta: null,
    actualizarCarpeta: carpeta => set( state => ({
        carpeta
    })),
    listaArchivos: [],
    actualizarListaArchivos: listaArchivos => set( state => ({
        listaArchivos
    })),

    listaArchivosOtros: [],
    actualizarListaArchivosOtros: listaArchivosOtros => set( state => ({
        listaArchivosOtros
    })),

    jsonArchivos: [],
    actualizarJsonArchivos: jsonArchivos => set( state => ({
        jsonArchivos
    })),

    toast: false,
    setToast: toast => set( state => ({
        toast
    })),

    aceptado: false,
    setAceptado: aceptado => set( state => ({
        aceptado
    })),

    objLogueado: obj,
    setObjLogueado: obj => set( state => ({
        objLogueado: obj
    })),

    datosCompletos: {
        nombre: "",
        apellidos: "",
        fecha_ingreso: "",
        escolaridad: "",
        carrera: "",
        escuela: "",
        cedula: "",
        rfc: "",
        nss: "",
        curp: "",
        fnac: "",
        edad: "",
        nacionalidad: "",
        estado_civil: "0",
        sexo: "0",
        tel: "",
        celular: "",
        domicilio: "",
        email: "",
        exp_docente: "",
        exp_sector: "",
        lentes: "",
        hijos: "",
        estudiando: "",
        problema: "",
        familiar: "",
    },
    setDatosCompletos: dataComplete => set( state => ({
        datosCompletos: dataComplete
    })),

    notificacionesIndividuales: [],
    setNotificacionesIndividuales: notificacionesIndividuales => set( state => ({
        notificacionesIndividuales
    })),

    idEmpleadoVacaciones: null,
    setIdEmpleadoVacaciones: idEmpleadoVacaciones => set( state => ({
        idEmpleadoVacaciones
    })),

    listaVacacionesEmpleado: [],
    setListaVacacionesEmpleado: listaVacacionesEmpleado => set( state => ({
        listaVacacionesEmpleado
    })),

    editarVacacionesEmpleado: {},
    setEditarVacacionesEmpleado: editarVacacionesEmpleado => set( state => ({
        editarVacacionesEmpleado
    })),

    cargandoVacacionesEmpleado: {},
    setCargandoVacacionesEmpleado: cargandoVacacionesEmpleado => set( state => ({
        cargandoVacacionesEmpleado
    })),

    vacationsYear: new Date().getFullYear(),
    setVacationsYear: vacationsYear => set( state => ({
        vacationsYear
    })),

    diasVacaciones: null,
    setDiasVacaciones: diasVacaciones => set( state => ({
        diasVacaciones
    })),

    diasVacacionesSumados: null,
    setDiasVacacionesSumados: diasVacacionesSumados => set( state => ({
        diasVacacionesSumados
    })),
}))
